export default __webpack_public_path__ + "static/media/livechat.5c3db030.svg";